import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Common
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveIcon } from '$common/icons/remove'
import { EditOutlinedIcon } from '$common/icons'
import { openEditContact } from '$logic/router'
import { showDeleteContactModal } from '$comp/modals/confirmation-dialog'
// Localization
import { t } from '$i18n'

interface Props {
  userId: string
  isOpen: boolean
}

export function ContactMenu({ userId, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('contacts.editContact')}
        onClick={async () => {
          await closeCurrentModal()
          openEditContact(userId)
        }}
      >
        <EditOutlinedIcon sx={{ color: 'secondary.main' }} />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('profile.user.deleteContact')}
        onClick={async () => {
          await showDeleteContactModal(userId)
          await closeCurrentModal()
        }}
      >
        <RemoveIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
